// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"awxwA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createSkeletons", ()=>createSkeletons);
parcelHelpers.export(exports, "addSkeleton", ()=>addSkeleton);
parcelHelpers.export(exports, "removeExtraSkeletons", ()=>removeExtraSkeletons);
parcelHelpers.export(exports, "getAvailableSkeleton", ()=>getAvailableSkeleton);
parcelHelpers.export(exports, "displayStars", ()=>displayStars);
parcelHelpers.export(exports, "getStars", ()=>getStars);
parcelHelpers.export(exports, "getLanguage", ()=>getLanguage);
parcelHelpers.export(exports, "stopContentLoading", ()=>stopContentLoading);
var _translatorJs = require("../custom/translator.js");
var _customHeaderJs = require("../custom/CustomHeader.js");
var _userHeaderJs = require("../custom/UserHeader.js");
var _campaignSliderJs = require("../custom/CampaignSlider.js");
var _campaignGridJs = require("../custom/CampaignGrid.js");
var _customFooterJs = require("../custom/CustomFooter.js");
var _skeletonJs = require("../custom/Skeleton.js");
var _commonJs = require("./common.js");
(0, _translatorJs.i18n).setGlobalData({
    year: new Date().getFullYear()
});
$('document').ready(function() {
//initCampScroll();
});
function createSkeletons(template, count = 2, container) {
    const references = [];
    for(let i = 0; i < count; i++){
        const clone = template.content.cloneNode(true);
        const skeleton = clone.querySelector('custom-skeleton');
        skeleton.classList.add('page-placeholder'); //marked as temporary
        references.push(skeleton);
        container.appendChild(clone);
    }
    return references;
}
function addSkeleton(templateNode, container) {
    const clone = templateNode.content.cloneNode(true);
    const newCard = clone.querySelector('custom-skeleton');
    container.appendChild(clone);
    //return [clone, newCard];
    return newCard;
}
function removeExtraSkeletons(container) {
    const leftoverSkeletons = container.querySelectorAll('custom-skeleton.page-placeholder');
    leftoverSkeletons.forEach((skeleton)=>{
        skeleton.remove();
    });
}
function getAvailableSkeleton(key, container, template) {
    let existingCard = document.getElementById(key);
    if (existingCard) return existingCard;
    let availableSkeleton = container.querySelector('custom-skeleton.page-placeholder');
    if (availableSkeleton) {
        availableSkeleton.classList.remove('page-placeholder');
        return availableSkeleton;
    } else return addSkeleton(template, container);
}
function displayStars(container, score) {
    //const container = document.getElementById("star-container");
    // 1. Get the numeric rating from data attribute and round it
    const rating = Math.round(parseFloat(score || container.getAttribute('data-rating')));
    const maxStars = 5;
    // 2. Generate filled and empty star strings using .repeat()
    const filledStars = "\u2605".repeat(rating);
    const emptyStars = "\u2606".repeat(maxStars - rating);
    // 3. Inject the complete star string into the element
    container.innerHTML = filledStars + emptyStars;
}
function getStars(rating) {
    console.log('rating: ', rating);
    const ratingNum = Math.round(parseFloat(rating));
    const maxStars = 5;
    // 2. Generate filled and empty star strings using .repeat()
    const filledStars = "\u2605".repeat(rating);
    const emptyStars = "\u2606".repeat(maxStars - rating);
    return filledStars + emptyStars;
}
// export function initCampScroll() {
//   const container = document.getElementById('campaignSlider');
//   const leftArrow = document.getElementById('navLeft');
//   const rightArrow = document.getElementById('navRight');
//   if (!container || !leftArrow || !rightArrow) {
//     return;
//   }
//   const scrollAmount = 320;
//   // Attach click events safely inside JavaScript
//   leftArrow.addEventListener('click', () => {
//     container.scrollBy({
//       left: -scrollAmount,
//       behavior: 'smooth',
//     });
//   });
//   rightArrow.addEventListener('click', () => {
//     container.scrollBy({
//       left: scrollAmount,
//       behavior: 'smooth',
//     });
//   });
// }
// app.js
function setupGlobalCampaignListeners() {
    document.body.addEventListener('click', (event)=>{
        // 1. Use composedPath() to find the real clicked element, even inside a Shadow DOM
        const path = event.composedPath();
        // Find if any element in the click path has the zeffy-form-link attribute
        const targetButton = path.find((element)=>element.hasAttribute && element.hasAttribute('zeffy-form-link'));
        // If no zeffy link was clicked, exit immediately
        if (!targetButton) return;
        // Stop any alternative behaviors or duplicate listener leaks
        event.preventDefault();
        event.stopPropagation();
        // 2. Fetch the current language-localized link variant from the active element
        const activeZeffyUrl = targetButton.getAttribute('zeffy-form-link');
        if (!activeZeffyUrl) return;
        // 3. Render your custom modal wrapper layout cleanly
        let zeffyModal = document.getElementById('zeffy-modal-container');
        if (!zeffyModal) {
            zeffyModal = document.createElement('div');
            zeffyModal.id = 'zeffy-modal-container';
            Object.assign(zeffyModal.style, {
                position: 'fixed',
                top: '0',
                left: '0',
                width: '100vw',
                height: '100vh',
                backgroundColor: 'rgba(0, 0, 0, 0.75)',
                zIndex: '99999',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            });
            const modalWrapper = document.createElement('div');
            Object.assign(modalWrapper.style, {
                position: 'relative',
                width: '500px',
                height: '85vh'
            });
            const closeBtn = document.createElement('button');
            closeBtn.innerHTML = '&times;';
            closeBtn.setAttribute('aria-label', 'Close donation modal');
            Object.assign(closeBtn.style, {
                position: 'absolute',
                top: '-40px',
                right: '0',
                background: 'none',
                border: 'none',
                color: '#ffffff',
                fontSize: '36px',
                cursor: 'pointer',
                lineHeight: '1',
                padding: '5px'
            });
            closeBtn.addEventListener('click', ()=>zeffyModal.remove());
            const iframe = document.createElement('iframe');
            iframe.src = activeZeffyUrl;
            iframe.title = 'Zeffy Donation Form';
            Object.assign(iframe.style, {
                width: '100%',
                height: '100%',
                border: 'none',
                borderRadius: '12px',
                backgroundColor: '#fff',
                boxShadow: '0px 10px 30px rgba(0,0,0,0.3)'
            });
            zeffyModal.addEventListener('click', (e)=>{
                if (e.target === zeffyModal) zeffyModal.remove();
            });
            modalWrapper.appendChild(closeBtn);
            modalWrapper.appendChild(iframe);
            zeffyModal.appendChild(modalWrapper);
            document.body.appendChild(zeffyModal);
        }
    });
}
function getLanguage() {
    return localStorage.getItem('preferredLanguage') || navigator.language.slice(0, 2);
}
function stopContentLoading() {
    const activeBones = document.querySelectorAll('.shimmer-bone');
    activeBones.forEach((bone)=>{
        bone.classList.remove('shimmer-bone', 'is-circle');
    });
}
function initCountries() {
    const countriesSelect = document.querySelectorAll('select[load-country="true"]');
    if (!countriesSelect) return;
    const lang = getLanguage();
    countriesSelect.forEach((element)=>{
        (0, _commonJs.loadCountries)(lang, element);
    });
}
function initLanguages() {
    const languagesSelect = document.querySelectorAll('select[load-language="true"]');
    if (!languagesSelect) return;
    const lang = getLanguage();
    languagesSelect.forEach((element)=>{
        (0, _commonJs.loadLangList)(lang, element);
    });
}
function initCampaignPrograms() {
    const campaignSelect = document.querySelectorAll('select[load-campaign="true"]');
    if (!campaignSelect) return;
    campaignSelect.forEach((element)=>{
        (0, _commonJs.loadCampaignPrograms)(element);
        (0, _translatorJs.i18n).translatePage(element);
    });
}
// Initialize the global campaign link click framework loop
setupGlobalCampaignListeners();
initCountries();
initLanguages();
initCampaignPrograms();

},{"../custom/translator.js":"eJcTf","../custom/CustomHeader.js":"3aCFy","../custom/UserHeader.js":"lUubX","../custom/CampaignSlider.js":"kJwaw","../custom/CampaignGrid.js":"1lftq","../custom/CustomFooter.js":"kTvFh","../custom/Skeleton.js":"bBdLh","./common.js":"jYzpo","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3aCFy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _translatorJs = require("../custom/translator.js");
var _globalCss = require("url:../styles/global.css");
var _globalCssDefault = parcelHelpers.interopDefault(_globalCss);
var _logoSvg = require("url:../images/logo.svg");
var _logoSvgDefault = parcelHelpers.interopDefault(_logoSvg);
var _phUserSvg = require("url:../images/svg/ph-user.svg");
var _phUserSvgDefault = parcelHelpers.interopDefault(_phUserSvg);
class CustomHeader extends HTMLElement {
    constructor(){
        super();
        // Crucial: Must be set to 'open' so our scanner can access it
        this.attachShadow({
            mode: 'open'
        });
        //this.shadowRoot.adoptedStyleSheets = [globalStyles];
        // 1. Initialize private backing fields with default fallback URLs
        this._androidUrl = 'https://play.google.com/store/apps/details?id=app.myandroidhello.com.chatmurcianys&pcampaignid=web_share';
        this._iosUrl = 'https://apps.apple.com/in/app/chatmurcianys/id6480422290';
        this._desktopUrl = 'https://p1mm.org';
        //this._zeffyLink = '';
        this._zeffyCampaign = 'donate-to-change-lives-6222';
    }
    // 1. Tell the component which attributes to watch
    static get observedAttributes() {
        return [
            'android-url',
            'ios-url',
            'desktop-url',
            'zeffy-campaign'
        ];
    }
    // 2. Automatically re-run the logic if an attribute changes
    attributeChangedCallback(name, oldValue, newValue) {
        // if (oldValue !== newValue && name === 'zeffy-link') {
        //   this._zeffyLink = newValue;
        // }
        if (oldValue !== newValue && name === 'zeffy-campaign') {
            this._zeffyCampaign = newValue;
            this.updateCampaignBtn(this._zeffyCampaign);
            return;
        }
        if (oldValue !== newValue && this.shadowRoot.innerHTML) this.setupDownloadButton();
    }
    updateCampaignBtn(zeffyCampaign) {
        const btnDonate = this.shadowRoot.querySelector('.btn-donate-nav');
        console.log('Updating campaign button with zeffyCampaign:', zeffyCampaign);
        if (btnDonate) {
            btnDonate.setAttribute('data-i18n-data', `{"campaign":"${zeffyCampaign}"}`);
            (0, _translatorJs.i18n).translatePage(btnDonate);
        }
    }
    // get activeZeffyLink() {
    //   const attrValue = this.getAttribute('zeffy-link');
    //   // If the attribute is missing or empty, output our explicit i18n flag
    //   return attrValue !== null && attrValue.trim() !== ''
    //     ? attrValue.trim()
    //     : 'from-i18n';
    // }
    get activeZeffyCampaign() {
        const attrValue = this.getAttribute('zeffy-campaign');
        // If the attribute is missing or empty, output our explicit i18n flag
        return attrValue !== null && attrValue.trim() !== '' ? attrValue.trim() : this._zeffyCampaign;
    }
    render() {
        // const zeffyLink = this.activeZeffyLink;
        const zeffyCampaign = this.activeZeffyCampaign;
        this.shadowRoot.innerHTML = `
    <link rel="stylesheet" href="${0, _globalCssDefault.default}">
    <!-- Header Navigation -->
    <header class="navbar">
      <div class="logo">
        <a href="index.html">
          <img
            src="${0, _logoSvgDefault.default}"
            alt="P1MM Logo"
            width="48px"
            data-i18n-attr='{"alt":"p1mm_logo"}'
          />
          <span data-i18n="head_p1mm">Por Un Mundo Mejor</span>
        </a>
      </div>
      <div class="nav-main-drop">
        <button
          class="nav-toggle"
          aria-label="Toggle navigation"
          data-i18n-attr='{"aria-label":"toggle_nav"}'
        >
          <span class="hamburger"></span>
        </button>

        <nav class="nav-links h-flex">
          <a href="index.html" data-i18n="nav_home">Home</a>
          <div class="nav-dropdown">
            <a href="#" class="dropdown-trigger"
              ><span data-i18n="nav_about">About Us</span>
              <span class="arrow">\u{25BC}</span></a
            >
            <div class="submenu">
              <a href="about.html" data-i18n="nav_mission">Our Mission</a>
              <!-- <a href="team.html">Meet the Team</a> -->
              <!-- <a href="work.html">Our Work</a> -->
              <a href="projects.html" data-i18n="nav_current_projects"
                >Current Projects</a
              >
              <!-- <a href="credentials.html">Credentials</a> -->
            </div>
          </div>
          <a href="projects.html" data-i18n="nav_projects">Projects</a>
          <a href="join.html" data-i18n="nav_join_us">Join Us</a>
        </nav>
      </div>

      <div class="nav-actions">
        <button
          data-i18n="donate"
          class="btn-donate-nav"
          data-i18n-data='{"campaign":"${zeffyCampaign}"}'
          data-i18n-attr='{"zeffy-form-link":"zeffy_popup"}'
          zeffy-form-link="https://zeffy.com"
        >
          Donate
        </button>
        <select class="lang-select" id="selLang">
          <option value="en" selected title="en">English</option>
          <option value="es" title="es">Espa\xf1ol</option>
        </select>

        <!-- User Login / Profile Picture Option -->
        <div class="user-profile-menu display-none" id="mnUserProfile">
          <!-- If logged out: <button class="btn-login">Volunteer Login</button> -->
          <!-- If logged in (Current View): -->
          <img
            src="${0, _phUserSvgDefault.default}"
            alt="User Profile"
            class="profile-avatar"
            data-i18n-attr='{"alt":"nav_user_profile"}'
          />
          <span class="profile-name"
            ><span id="pfName">Oscar R.</span> <span>\u{25BC}</span></span
          >
        </div>
      </div>
    </header>
    `;
    }
    connectedCallback() {
        this.render();
        //this.initZeffy();
        const switcher = this.shadowRoot.getElementById('selLang');
        (0, _translatorJs.i18n).initFromElement(switcher);
        //this.initDownloadButton();
        this.initMobileNav();
    }
    initMobileNav() {
        // const burgerBtn = this.shadowRoot.getElementById('burgerBtn');
        // const mobileNav = this.shadowRoot.getElementById('mobileNav');
        // burgerBtn.addEventListener('click', () => {
        //   burgerBtn.classList.toggle('open');
        //   mobileNav.classList.toggle('open');
        // });
        const navToggle = this.shadowRoot.querySelector('.nav-toggle');
        const navLinks = this.shadowRoot.querySelector('.nav-links');
        if (navToggle && navLinks) {
            navToggle.addEventListener('click', ()=>{
                // Toggle the animation utility classes on both elements
                navToggle.classList.toggle('is-active');
                navLinks.classList.toggle('is-active');
            });
            // Close the menu automatically if a user clicks an internal link
            navLinks.querySelectorAll('a:not(.dropdown-trigger)').forEach((link)=>{
                link.addEventListener('click', ()=>{
                    navToggle.classList.remove('is-active');
                    navLinks.classList.remove('is-active');
                });
            });
        }
        // 2. NEW: Submenu Toggle for Mobile Touchscreens
        const dropdownTrigger = this.shadowRoot.querySelector('.dropdown-trigger');
        const navDropdown = this.shadowRoot.querySelector('.nav-dropdown');
        if (dropdownTrigger && navDropdown) dropdownTrigger.addEventListener('click', (e)=>{
            // Only run this logic on mobile screens
            if (window.innerWidth <= 1000) {
                e.preventDefault(); // Stop the browser from instantly following the '#' link
                navDropdown.classList.toggle('is-open'); // Toggles open/closed states cleanly
            }
        });
    }
    initDownloadButton() {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        const downloadBtn = this.shadowRoot.getElementById('downloadNavTrigger');
        // Modal DOM References
        const downloadModal = this.shadowRoot.getElementById('downloadModal');
        const closeModalBtn = this.shadowRoot.getElementById('closeModalBtn');
        const downloadNavTrigger = this.shadowRoot.getElementById('downloadNavTrigger');
        if (!downloadBtn) return;
        // 3. Evaluate device type and apply the property values
        if (/android/i.test(userAgent)) {
            downloadBtn.href = this._androidUrl;
            downloadBtn.textContent = 'Google Play';
        } else if (/iPad|iPhone|iPod/i.test(userAgent)) {
            downloadBtn.href = this._iosUrl;
            downloadBtn.textContent = 'App Store';
        } else {
            downloadBtn.href = this._desktopUrl;
            downloadBtn.textContent = 'Desktop App';
            // Helper functions to open and close
            const openModal = (e)=>{
                e.preventDefault();
                downloadModal.classList.add('modal-open');
                downloadModal.setAttribute('aria-hidden', 'false');
            };
            const closeModal = ()=>{
                downloadModal.classList.remove('modal-open');
                downloadModal.setAttribute('aria-hidden', 'true');
            };
            // Event Trigger Listeners
            if (downloadNavTrigger) downloadNavTrigger.addEventListener('click', openModal);
            closeModalBtn.addEventListener('click', closeModal);
            // Close modal instantly if the user clicks out in the blurred layout mask area
            downloadModal.addEventListener('click', (e)=>{
                if (e.target === downloadModal) closeModal();
            });
            // Accessibility: Allow hitting the Escape key to exit out of the modal frame
            document.addEventListener('keydown', (e)=>{
                if (e.key === 'Escape' && downloadModal.classList.contains('modal-open')) closeModal();
            });
        }
    }
}
// Register the custom elements
customElements.define('custom-header', CustomHeader);

},{"../custom/translator.js":"eJcTf","url:../styles/global.css":"4fKTw","url:../images/logo.svg":"ekzHI","url:../images/svg/ph-user.svg":"5j1ph","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4fKTw":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("ekcZ8");

},{}],"ekzHI":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("4SElo");

},{}],"5j1ph":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("kDufI");

},{}],"91HVb":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"lUubX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _translatorJs = require("./translator.js");
var _globalCss = require("url:../styles/global.css");
var _globalCssDefault = parcelHelpers.interopDefault(_globalCss);
var _portalCss = require("url:../styles/portal.css");
var _portalCssDefault = parcelHelpers.interopDefault(_portalCss);
var _logoSvg = require("url:../images/logo.svg");
var _logoSvgDefault = parcelHelpers.interopDefault(_logoSvg);
var _phUserSvg = require("url:../images/svg/ph-user.svg");
var _phUserSvgDefault = parcelHelpers.interopDefault(_phUserSvg);
class UserHeader extends HTMLElement {
    constructor(){
        super();
        // Crucial: Must be set to 'open' so our scanner can access it
        this.attachShadow({
            mode: 'open'
        });
        //this.shadowRoot.adoptedStyleSheets = [globalStyles];
        // 1. Initialize private backing fields with default fallback URLs
        this._desktopUrl = 'https://p1mm.org';
        this._loading = true;
        this._userName = '';
        this._avatarUrl = '';
        this._isAdmin = false;
    }
    // 1. Tell the component which attributes to watch
    static get observedAttributes() {
        return [
            'loading',
            'user-name',
            'avatar-url',
            'is-admin'
        ];
    }
    // 2. Automatically re-run the logic if an attribute changes
    attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue === newValue) return;
        if (name === 'is-admin') {
            this._isAdmin = newValue === 'true';
            this.toggleCaseTabs(this._isAdmin);
            return;
        }
        // Track internally
        if (name === 'loading') this._loading = newValue !== 'false' && newValue !== null;
        if (name === 'user-name') this._userName = newValue;
        if (name === 'avatar-url') this._avatarUrl = newValue;
        // Direct DOM sync loop: Only manipulate elements if the shell is built
        if (this.shadowRoot.getElementById('navbar-header')) this.syncDOMState();
    }
    toggleCaseTabs(isAdmin) {
        const caseTabLinks = document.querySelectorAll('[data-target="panel-cases"]');
        caseTabLinks.forEach((link)=>{
            link.style.display = isAdmin ? 'flex' : 'none';
        });
        document.getElementById('sidebar-drawer').classList.remove('loading-skeleton');
        document.querySelector('.sub-nav-tabs').classList.remove('loading-skeleton');
    }
    // TODO: START here: copy header from new index.html
    render() {
        this.shadowRoot.innerHTML = `
    <link rel="stylesheet" href="${0, _globalCssDefault.default}">
    <link rel="stylesheet" href="${0, _portalCssDefault.default}">
    <style>
      /* --- INFINITE SHIMMER ANIMATION ENGINE --- */
      @keyframes shimmerWave {
          0% { background-position: -200% 0; }
          100% { background-position: 200% 0; }
      }

      /* 1. Base styles for fields in their normal (loaded) state */
      .top-navbar .profile-avatar,
      .top-navbar .profile-name,
      .top-navbar .drop-link {
          /* Smoothly animate background modifications and color transitions */
          transition: background-color 0.4s ease, color 0.4s ease, border-color 0.4s ease;
          background-color: transparent;
          color: inherit;
      }

      /* 2. Overriding styles applied dynamically while actively loading */
      .top-navbar.is-loading .profile-avatar,
      .top-navbar.is-loading .profile-name,
      .top-navbar.is-loading .drop-link {
          color: transparent !important;
          border-color: transparent !important;
          pointer-events: none;
          border-radius: 4px;
          
          background: linear-gradient(
              90deg, 
              #f1f5f9 25%, 
              #cbd5e1 50%, 
              #f1f5f9 75%
          );
          background-size: 200% 100%;
          animation: shimmerWave 1.6s infinite linear;
      }

      /* Ensure the avatar stays perfectly circular in both states */
      .top-navbar .profile-avatar {
          border-radius: 50%;
      }
      .top-navbar.is-loading .profile-avatar {
          border-radius: 50% !important;
      }

      /* Turn off menu dropdown hover effects if the bar is actively loading */
      .top-navbar.is-loading .user-profile-menu:hover .user-profile-dropdown {
          display: none !important;
          opacity: 0 !important;
          visibility: hidden !important;
      }   
    </style>
    <!-- Header Navigation -->
    <header class="top-navbar ${this._loading ? 'is-loading' : ''}">
      <div class="nav-left">
        <button
          id="drawer-toggle"
          class="nav-toggle"
          aria-label="Toggle navigation"
          data-i18n-attr='{"aria-label":"toggle_nav"}'
          >
          <span class="hamburger"></span>
        </button>
        <div class="logo">
          <a href="index.html">
            <img
              src="${0, _logoSvgDefault.default}"
              alt="P1MM Logo"
              width="48px"
              data-i18n-attr='{"alt":"p1mm_logo"}'
            />
            <span data-i18n="head_p1mm">Por Un Mundo Mejor</span>
          </a>
        </div>
      </div>

      <div class="nav-right">
           <button
          data-i18n="donate"
          class="btn-donate-nav"
          data-i18n-attr='{"zeffy-form-link":"zeffy_donation_url"}'
          zeffy-form-link=""
        >
          Donate
        </button>
        <select class="lang-select" id="selLang">
          <option value="en" selected title="en">English</option>
          <option value="es" title="es">Espa\xf1ol</option>
        </select>

        <!-- User Login / Profile Picture Option -->
        <div class="h-flex user-profile-menu pos-rel" id="mnUserProfile">
          <img
             src="${this._loading ? (0, _phUserSvgDefault.default) : this._avatarUrl || (0, _phUserSvgDefault.default)}"
            alt="User Profile"
            class="profile-avatar"
            id="header-avatar-img"
            data-i18n-attr='{"alt":"nav_user_profile"}'
          />
          <span class="profile-name"
            ><span id="pfName">${this._loading ? 'Loading...' : this._userName || 'User'}</span> <span>\u{25BC}</span></span
          >
          <div class="user-profile-dropdown">
            <button class="drop-link" data-target="panel-profile" data-i18n="profile">Profile</button>
            <button id="btnLogout" data-i18n="logout">Logout</button>
          </div>
        </div>
      </div>
    </header>
    `;
    }
    connectedCallback() {
        this.buildBaseStructure();
        // 2. Initialize language selection switcher and custom dashboard events
        const switcher = this.shadowRoot.getElementById('selLang');
        if (switcher && typeof (0, _translatorJs.i18n) !== 'undefined') (0, _translatorJs.i18n).initFromElement(switcher);
        this.initDashboard();
    // window.addEventListener('name-updated', (e) => {
    //   const headerName = this.shadowRoot.getElementById('pfName');
    //   if (headerName && e.detail.newName) {
    //     headerName.textContent = e.detail.newName;
    //   }
    // });
    }
    // Generates the layout layout, styles, and links ONE time
    buildBaseStructure() {
        this.shadowRoot.innerHTML = `
      <link rel="stylesheet" href="${0, _globalCssDefault.default}">
      <link rel="stylesheet" href="${0, _portalCssDefault.default}">
      <style>
        /* --- INFINITE SHIMMER ANIMATION ENGINE --- */
        @keyframes shimmerWave {
          0% { background-position: -200% 0; }
          100% { background-position: 200% 0; }
        }
        .top-navbar .profile-avatar, .top-navbar .profile-name, .top-navbar .drop-link {
          transition: background-color 0.4s ease, color 0.4s ease, border-color 0.4s ease;
          background-color: transparent;
          color: inherit;
        }
        .top-navbar.is-loading .profile-avatar, .top-navbar.is-loading .profile-name, .top-navbar.is-loading .drop-link {
          color: transparent !important;
          border-color: transparent !important;
          pointer-events: none;
          border-radius: 4px;
          background: linear-gradient(90deg, #f1f5f9 25%, #cbd5e1 50%, #f1f5f9 75%);
          background-size: 200% 100%;
          animation: shimmerWave 1.6s infinite linear;
        }
        .top-navbar .profile-avatar { border-radius: 50%; }
        .top-navbar.is-loading .profile-avatar { border-radius: 50% !important; }
        .top-navbar.is-loading .user-profile-menu:hover .user-profile-dropdown {
          display: none !important;
          opacity: 0 !important;
          visibility: hidden !important;
        }
      </style>

      <header id="navbar-header" class="top-navbar is-loading">
        <div class="nav-left">
          <button id="drawer-toggle" class="nav-toggle" aria-label="Toggle navigation" data-i18n-attr='{"aria-label":"toggle_nav"}'>
            <span class="hamburger"></span>
          </button>
          <div class="logo">
            <a href="index.html">
              <img src="${0, _logoSvgDefault.default}" alt="P1MM Logo" width="48px" data-i18n-attr='{"alt":"p1mm_logo"}' />
              <span data-i18n="head_p1mm">Por Un Mundo Mejor</span>
            </a>
          </div>
        </div>
        <div class="nav-right">
          <button data-i18n="donate" class="btn-donate-nav" data-i18n-attr='{"zeffy-form-link":"zeffy_donation_url"}' zeffy-form-link="">
            Donate
          </button>
          <select class="lang-select" id="selLang">
            <option value="en" selected title="en">English</option>
            <option value="es" title="es">Espa\xf1ol</option>
          </select>
          <div class="h-flex user-profile-menu pos-rel" id="mnUserProfile">
            <img src="${0, _phUserSvgDefault.default}" alt="User Profile" class="profile-avatar" id="header-avatar-img" data-i18n-attr='{"alt":"nav_user_profile"}' />
            <span class="profile-name">
              <span id="pfName">Loading...</span>
              <span>\u{25BC}</span>
            </span>
            <div class="user-profile-dropdown">
              <button class="drop-link" data-target="panel-profile" data-i18n="profile">Profile</button>
              <button id="btnLogout" data-i18n="logout">Logout</button>
            </div>
          </div>
        </div>
      </header>
    `;
        // Set immediate initial layout attributes before network responses return
        this.syncDOMState();
    }
    // Pinpoint targeted elements for state sync—No layout breakdown
    syncDOMState() {
        const header = this.shadowRoot.getElementById('navbar-header');
        const avatarImg = this.shadowRoot.getElementById('header-avatar-img');
        const nameSpan = this.shadowRoot.getElementById('pfName');
        if (!header) return;
        // Toggle parent CSS layout class to mask/unmask loader shimmer
        header.classList.toggle('is-loading', this._loading);
        if (this._loading) {
            if (avatarImg) avatarImg.src = (0, _phUserSvgDefault.default);
            if (nameSpan) nameSpan.textContent = 'Loading...';
        } else {
            if (avatarImg) avatarImg.src = this._avatarUrl || (0, _phUserSvgDefault.default);
            if (nameSpan) nameSpan.textContent = this._userName || 'User';
        }
    }
    initDashboard() {
        // 1. Mobile Sidebar Navigation Slider Handler Toggle
        const drawerToggle = this.shadowRoot.getElementById('drawer-toggle');
        const sidebarDrawer = document.getElementById('sidebar-drawer');
        drawerToggle.addEventListener('click', (e)=>{
            sidebarDrawer.classList.toggle('open');
            e.stopPropagation();
        });
        // Close sidebar layout if clicking outside card frames on mobile screen sizes
        document.addEventListener('click', (e)=>{
            if (window.innerWidth <= 1000 && !sidebarDrawer.contains(e.target) && sidebarDrawer.classList.contains('open')) sidebarDrawer.classList.remove('open');
        });
        const mainTabLinks = document.querySelectorAll('.tab-link');
        const shadowDropLinks = this.shadowRoot.querySelectorAll('.drop-link');
        const sidebarLinks = document.querySelectorAll('.sidebar-link');
        // Combine both sets of buttons into a single array loop
        const allTabLinks = [
            ...mainTabLinks,
            ...shadowDropLinks,
            ...sidebarLinks
        ];
        const tabPanels = document.querySelectorAll('.tab-panel');
        allTabLinks.forEach((link)=>{
            link.addEventListener('click', ()=>{
                // Clear active classes from ALL tracked navigation links
                allTabLinks.forEach((item)=>item.classList.remove('active'));
                tabPanels.forEach((panel)=>panel.classList.remove('active'));
                // Find the specific panel targeted by this click
                const targetId = link.getAttribute('data-target');
                console.log('Target ID for tab click:', targetId);
                const targetPanel = document.getElementById(targetId);
                if (targetPanel) {
                    targetPanel.classList.add('active');
                    // Match state: If a corresponding sidebar/sub-nav tab button exists for this view, highlight it too!
                    allTabLinks.forEach((item)=>{
                        if (item.getAttribute('data-target') === targetId) item.classList.add('active');
                    });
                    this.dispatchEvent(new CustomEvent('tab-changed', {
                        detail: {
                            activeTabId: targetId
                        },
                        bubbles: true,
                        composed: true
                    }));
                }
            });
        });
        const btnLogout = this.shadowRoot.getElementById('btnLogout');
        if (btnLogout) btnLogout.addEventListener('click', ()=>{
            this.dispatchEvent(new CustomEvent('logout', {
                bubbles: true,
                composed: true
            }));
        });
        const headerAvatar = this.shadowRoot.getElementById('header-avatar-img');
        if (headerAvatar) {
            // If the image is already cached/loaded by the browser, make sure it's visible
            if (headerAvatar.complete) headerAvatar.style.opacity = '1';
            else {
                // Start hidden, then fade in once the bytes finish downloading
                headerAvatar.style.opacity = '0';
                headerAvatar.style.transition = 'opacity 0.4s ease';
                headerAvatar.addEventListener('load', ()=>{
                    headerAvatar.style.opacity = '1';
                });
            }
        }
    }
    initMobileNav() {
        // const burgerBtn = this.shadowRoot.getElementById('burgerBtn');
        // const mobileNav = this.shadowRoot.getElementById('mobileNav');
        // burgerBtn.addEventListener('click', () => {
        //   burgerBtn.classList.toggle('open');
        //   mobileNav.classList.toggle('open');
        // });
        const navToggle = this.shadowRoot.querySelector('.nav-toggle');
        const navLinks = this.shadowRoot.querySelector('.nav-links');
        if (navToggle && navLinks) {
            navToggle.addEventListener('click', ()=>{
                // Toggle the animation utility classes on both elements
                navToggle.classList.toggle('is-active');
                navLinks.classList.toggle('is-active');
            });
            // Close the menu automatically if a user clicks an internal link
            navLinks.querySelectorAll('a:not(.dropdown-trigger)').forEach((link)=>{
                link.addEventListener('click', ()=>{
                    navToggle.classList.remove('is-active');
                    navLinks.classList.remove('is-active');
                });
            });
        }
        // 2. NEW: Submenu Toggle for Mobile Touchscreens
        const dropdownTrigger = this.shadowRoot.querySelector('.dropdown-trigger');
        const navDropdown = this.shadowRoot.querySelector('.nav-dropdown');
        if (dropdownTrigger && navDropdown) dropdownTrigger.addEventListener('click', (e)=>{
            // Only run this logic on mobile screens
            if (window.innerWidth <= 1000) {
                e.preventDefault(); // Stop the browser from instantly following the '#' link
                navDropdown.classList.toggle('is-open'); // Toggles open/closed states cleanly
            }
        });
    }
}
// Register the custom elements
customElements.define('user-header', UserHeader);

},{"./translator.js":"eJcTf","url:../styles/global.css":"4fKTw","url:../styles/portal.css":"eAsXx","url:../images/logo.svg":"ekzHI","url:../images/svg/ph-user.svg":"5j1ph","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eAsXx":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("1iQkv");

},{}],"kJwaw":[function(require,module,exports,__globalThis) {
//import globalStylesUrl from 'url:../styles/global.css';
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _oscarJpeg = require("url:../images/vol/oscar.jpeg");
var _oscarJpegDefault = parcelHelpers.interopDefault(_oscarJpeg);
var _childHealthJpg = require("url:../images/pexel/child-health.jpg");
var _childHealthJpgDefault = parcelHelpers.interopDefault(_childHealthJpg);
var _teachJpg = require("url:../images/teach.jpg");
var _teachJpgDefault = parcelHelpers.interopDefault(_teachJpg);
var _hungerReliefPng = require("url:../images/hunger-relief.png");
var _hungerReliefPngDefault = parcelHelpers.interopDefault(_hungerReliefPng);
var _disasterJpg = require("url:../images/pexel/disaster.jpg");
var _disasterJpgDefault = parcelHelpers.interopDefault(_disasterJpg);
var _animalJpg = require("url:../images/pexel/animal.jpg");
var _animalJpgDefault = parcelHelpers.interopDefault(_animalJpg);
class CampaignSlider extends HTMLElement {
    constructor(){
        super();
    //this.attachShadow({ mode: 'open' });
    }
    // 1. Tell the browser which attributes to watch closely
    static get observedAttributes() {
        return [
            'exclude'
        ];
    }
    // 2. Automatically trigger a re-render if the exclude attribute changes
    attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'exclude' && oldValue !== newValue) this.render();
    }
    connectedCallback() {
        this.render();
        this.initCampScroll();
    }
    render() {
        const excludeCampaign = this.getAttribute('exclude');
        const campaigns = [
            {
                id: 'health',
                img: (0, _childHealthJpgDefault.default),
                title: 'health_care',
                pageUrl: '/health.html',
                altText: 'health_campaign',
                zeffyUrl: 'zeffy_health_link'
            },
            {
                id: 'edu',
                img: (0, _teachJpgDefault.default),
                title: 'edu_support',
                pageUrl: '/edu.html',
                altText: 'edu_campaign',
                zeffyUrl: 'zeffy_edu_link'
            },
            {
                id: 'hunger',
                img: (0, _hungerReliefPngDefault.default),
                title: 'hunger_relief',
                pageUrl: '/hunger.html',
                altText: 'hunger_campaign',
                zeffyUrl: 'zeffy_hunger_link'
            },
            {
                id: 'disasters',
                img: (0, _disasterJpgDefault.default),
                title: 'disaster_relief',
                pageUrl: '/disasters.html',
                altText: 'disaster_campaign',
                zeffyUrl: 'zeffy_disaster_link'
            },
            {
                id: 'animal',
                img: (0, _animalJpgDefault.default),
                title: 'animal_welfare',
                pageUrl: '/animals.html',
                altText: 'animal_campaign',
                zeffyUrl: 'zeffy_animal_link'
            }
        ];
        const cardsHtml = campaigns.filter((campaign)=>campaign.id !== excludeCampaign).map((campaign)=>{
            return `
          <div class="campaign-card">
            <img
              src="${campaign.img}"
              alt="${campaign.altText}"
              data-i18n-attr='{"alt":"${campaign.altText}"}'
              class="campaign-image exam"
            />
            <div class="campaign-overlay">
              <h3 class="campaign-title" data-i18n="${campaign.title}">
                ${campaign.title}
              </h3>
              <button
                class="campaign-btn"
                zeffy-form-link="https://www.zeffy.com/es/embed/donation-form/donate-to-save-lives-191?modal=true"
                data-i18n-attr='{"zeffy-form-link":"${campaign.zeffyUrl}"}'
                data-i18n="support_campaign"
              >
                Support This Campaign
              </button>
              <a class="camp-link" href="${campaign.pageUrl}">
                <span><i class="fa-solid fa-circle-info"></i></span
                ><span data-i18n="learn_more"></span
              ></a>
            </div>
          </div>
        `;
        }).join('');
        this.innerHTML = `
    
    <div class="campaign-wrapper">
      <!-- Left Navigation Arrow -->
      <button
        id="navLeft"
        class="nav-arrow left"
        data-i18n-attr='{"aria-label":"scroll_left"}'
        aria-label="Scroll left"
      >
        &#10094;
      </button>

      <!-- Scroll Container -->
      <div class="campaign-container" id="campaignSlider">
        ${cardsHtml}
      </div>

      <!-- Right Navigation Arrow -->
      <button
        id="navRight"
        class="nav-arrow right"
        data-i18n-attr='{"aria-label":"scroll_right"}'
        aria-label="Scroll right"
      >
        &#10095;
      </button>
    </div>
        `;
    }
    initCampScroll() {
        const container = document.getElementById('campaignSlider');
        const leftArrow = document.getElementById('navLeft');
        const rightArrow = document.getElementById('navRight');
        if (!container || !leftArrow || !rightArrow) return;
        const scrollAmount = 320;
        // Attach click events safely inside JavaScript
        leftArrow.addEventListener('click', ()=>{
            container.scrollBy({
                left: -scrollAmount,
                behavior: 'smooth'
            });
        });
        rightArrow.addEventListener('click', ()=>{
            container.scrollBy({
                left: scrollAmount,
                behavior: 'smooth'
            });
        });
    }
}
customElements.define('campaign-slider', CampaignSlider); // At the bottom of your custom element file:
 // if (module.hot) {
 //   module.hot.accept(() => {
 //     // Force a page reload when this specific file updates to bypass the customElement registry freeze
 //     window.location.reload();
 //   });
 // }

},{"url:../images/vol/oscar.jpeg":"hdnns","url:../images/pexel/child-health.jpg":"1fWre","url:../images/teach.jpg":"7rl7a","url:../images/hunger-relief.png":"eftzJ","url:../images/pexel/disaster.jpg":"ahuAa","url:../images/pexel/animal.jpg":"5SRQv","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hdnns":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("aOncq");

},{}],"1fWre":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("iAncC");

},{}],"7rl7a":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("SQAYQ");

},{}],"eftzJ":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("gEc1k");

},{}],"ahuAa":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("focsP");

},{}],"5SRQv":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("eLrc7");

},{}],"1lftq":[function(require,module,exports,__globalThis) {
class CampaignGrid extends HTMLElement {
    constructor(){
        super();
    //this.attachShadow({ mode: 'open' });
    }
    // 1. Tell the browser which attributes to watch closely
    static get observedAttributes() {
        return [
            'exclude'
        ];
    }
    // 2. Automatically trigger a re-render if the exclude attribute changes
    attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'exclude' && oldValue !== newValue) this.render();
    }
    connectedCallback() {
        this.render();
    }
    render() {
        const excludeCampaign = this.getAttribute('exclude');
        const campaigns = [
            {
                id: 'health',
                icon: "\uD83D\uDE91",
                title: 'health_care',
                pageUrl: '/health.html',
                desc: 'health_sum'
            },
            {
                id: 'edu',
                icon: "\uD83C\uDF93",
                title: 'edu_support',
                pageUrl: '/edu.html',
                desc: 'edu_sum'
            },
            {
                id: 'hunger',
                icon: "\uD83C\uDF7D\uFE0F",
                title: 'hunger_relief',
                pageUrl: '/hunger.html',
                desc: 'hunger_sum'
            },
            {
                id: 'disasters',
                icon: "\u26C8\uFE0F",
                title: 'disaster_relief',
                pageUrl: '/disasters.html',
                desc: 'disaster_sum'
            },
            {
                id: 'animal',
                icon: "\uD83D\uDC3E",
                title: 'animal_welfare',
                pageUrl: '/animals.html',
                desc: 'animal_sum'
            }
        ];
        const gridItemHtml = campaigns.filter((campaign)=>campaign.id !== excludeCampaign).map((campaign)=>{
            return `
          <div class="grid-item">
            <div class="campaign-item">
                <div class="icon-box">${campaign.icon}</div>
                <h3 data-i18n="${campaign.title}">${campaign.title}</h3>
            </div>
            <div class="campaign-text">
                <p data-i18n="${campaign.desc}">
                Provide a lifeline to those in need of critical medical care
                through financial assistance and medical resources.
                </p>
            </div>
            <div class="campaign-actions">
                <a
                href="${campaign.pageUrl}"
                data-i18n="learn_more"
                class="btn-secondary read-more"
                >Learn More</a
                >
            </div>
        </div>
        `;
        }).join('');
        this.innerHTML = `
    
    <div class="grid-container">
      ${gridItemHtml}
    </div>
        `;
    }
}
customElements.define('campaign-grid', CampaignGrid);

},{}],"kTvFh":[function(require,module,exports,__globalThis) {
class CustomFooter extends HTMLElement {
    connectedCallback() {
        this.innerHTML = `
            <!-- Footer -->
    <footer class="site-footer">
      <div class="footer-container">
        <!-- Column 1: Organization Credentials & Legal -->
        <div class="footer-col credentials-col">
          <h3>Por Un Mundo Mejor (P1MM)</h3>
          <p class="credential-id" data-i18n="foot_cred">
            Por Un Mundo Mejor is a registered 501(c)(3) nonprofit organization.
          </p>
          <a
            class="credential-id"
            href="docs/tax-exempt-search.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            <p class="credential-id" data-i18n="foot_ngo">
              NGO Registration No: 39-4366761
            </p>
          </a>

          <p class="footer-copy" data-i18n="foot_copy">
            &copy; Copyright 2026. All Rights Reserved.
          </p>
          <a href="policies.html" class="footer-link" data-i18n="foot_pol">Privacy & Policies</a>
        </div>

        <!-- Column 2: Direct Contact Channels -->
        <div class="footer-col contact-col">
          <h3 data-i18n="foot_contact">Contact Us</h3>
          <ul class="contact-list">
            <li>
              <a href="mailto:info@p1mm.org"
                ><i class="fas fa-envelope"></i> info@p1mm.org</a
              >
            </li>
            <li>
              <a href="tel:+1832-674-5331"
                ><i class="fas fa-phone"></i> +1 832-674-5331</a
              >
            </li>
            <li>
              <span class="location-text"
                ><i class="fas fa-map-marker-alt"></i> Houston, TX</span
              >
            </li>
          </ul>
        </div>

        <!-- Column 3: Social Connectivity -->
        <div class="footer-col socials-col">
          <h3 data-i18n="foot_follow">Follow Our Impact</h3>
          <div class="footer-socials">
            <a
              href="https://www.facebook.com/people/Por-Un-Mundo-Mejor/61589936751239/"
              target="_blank"
              rel="noopener"
              aria-label="Facebook"
              data-i18n-attr='{"aria-label":"fb"}'
            >
              <i class="fab fa-facebook-f"></i>
            </a>
            <!-- <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener"
              aria-label="Instagram"
            >
              <i class="fab fa-instagram"></i>
            </a>
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener"
              aria-label="LinkedIn"
            >
              <i class="fab fa-linkedin-in"></i>
            </a>
            <a
              href="https://youtube.com"
              target="_blank"
              rel="noopener"
              aria-label="YouTube"
            >
              <i class="fab fa-youtube"></i>
            </a> -->
            <a
              href="https://tiktok.com/@por.un.mundo.mejo90"
              target="_blank"
              rel="noopener"
              aria-label="TikTok"
              data-i18n-attr='{"aria-label":"tk"}'
            >
              <i class="fab fa-tiktok"></i>
            </a>
          </div>
          <div>Version: 1.0.0</div>
        </div>
      </div>
    </footer>
        `;
    }
}
// Register the custom elements
customElements.define('custom-footer', CustomFooter);

},{}],"bBdLh":[function(require,module,exports,__globalThis) {
class FlexibleSkeleton extends HTMLElement {
    constructor(){
        super();
        this.attachShadow({
            mode: "open"
        });
        this._loading = true;
        this._error = false;
    }
    static get observedAttributes() {
        return [
            "loading",
            "error"
        ];
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue === newValue) return;
        if (name === "loading") this._loading = newValue !== "false" && newValue !== null;
        if (name === "error") this._error = newValue !== "false" && newValue !== null;
        this.updateState();
    }
    connectedCallback() {
        this.render();
        this.updateState();
    }
    render() {
        this.shadowRoot.innerHTML = `
    <style>
      :host { display: block; }

      /* Default fallback style blocks - hidden state */
      slot[name="loading"], slot[name="content"], slot[name="error"] {
        display: none !important;
      }

      /* --- THE STATE SWAP ENGINE --- */
      :host([error]) slot[name="error"] { display: block !important; }
      :host([loading]:not([error])) slot[name="loading"] { display: block !important; }
      :host(:not([loading]):not([error])) slot[name="content"] { display: block !important; }
    </style>
    
    <slot name="loading"></slot>
    <slot name="content"></slot>
    <slot name="error"></slot>
  `;
    }
    updateState() {
        if (this._error) this.setAttribute("error", "");
        else this.removeAttribute("error");
        if (this._loading) this.setAttribute("loading", "");
        else this.removeAttribute("loading");
    }
}
customElements.define("custom-skeleton", FlexibleSkeleton);

},{}]},["awxwA"], "awxwA", "parcelRequiredd39", {})

//# sourceMappingURL=public.1a5aef02.js.map
